// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","LayoutPageWrapperDesktopScreenBreakpointMin":"(min-width: 640px)","subHead":"G8ca1bc Gfbbf38","copyOutOfCard":"Gf65a32"};